<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li *ngIf="analyticsFeatureEnabled && canManageSettings" [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Configurations' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-llm-configuration-main style="display: block"></ca-llm-configuration-main>
      </ng-template>
    </li>
    <li *ngIf="analyticsFeatureEnabled && canManageSettings" [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::AskGenAI' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-open-ai-settings></ca-open-ai-settings>
      </ng-template>
    </li>
    <li
      *ngIf="analyticsFeatureEnabled && canManageSettings && canManageTranslation"
      [ngbNavItem]="3">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Translation' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-translation-settings></ca-translation-settings>
      </ng-template>
    </li>
    <li
      *ngIf="analyticsFeatureEnabled && canManageSettings && summarizationFeatureEnabled"
      [ngbNavItem]="4">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::AIInsights' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-ai-insight-settings></ca-ai-insight-settings>
      </ng-template>
    </li>
    <li *ngIf="analyticsFeatureEnabled && canManageSettings" [ngbNavItem]="5">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::AIGeneratedCategoriesSettings' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-ai-topic-category-settings></ca-ai-topic-category-settings>
      </ng-template>
    </li>
    <li
      *ngIf="analyticsFeatureEnabled && askGenAIFeatureEnabled && canManageRootCause"
      [ngbNavItem]="6">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Definitions' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-setting-definitions
          [information]="'Settings::SettingsDefinitionInfo'"
          [items]="settingsDefinitionItems"></ca-setting-definitions>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" style="height: calc(100% - 120px)"></div>
</div>
